<template>
    <b-modal v-model="isShowPopup" dialog-class="modal-detail" @hidden="resetModal" scrollable :no-close-on-backdrop=true id="popup-upload" @ok="uploadButtonAction" :okTitle="okTitle" title="Upload Data">
        <b-card>
            <b-row>
                <b-col cols="12">
                    <app-input-fileupload label="File" size="sm" :model.sync="fileupload" />
                </b-col>
            </b-row>
            <b-row v-if="isUploadSuccess">
                <b-col cols="12">
					<b-card no-body>
						<b-tabs card>
							                            <b-tab title="Upload Delivery Instruction Subcontract" active>

                                <b-row v-if="hasFailedDataDeliveryInstructionSubcontract">
                                    <b-col>
                                        <b-button variant="danger" v-b-toggle.failed-content class="m-1">Invalid Data ({{ totalFailedDeliveryInstructionSubcontract.toLocaleString() }})</b-button>
                                        <b-collapse visible id="failed-content">
                                            <div class="table-corner">
                                                <b-table id="failed-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="deliveryInstructionSubcontractsFailed" :fields="fieldsDeliveryInstructionSubcontract" :busy="isDataLoading"
                                                         :sort-by.sync="sortByDeliveryInstructionSubcontract" :sort-desc.sync="sortDescDeliveryInstructionSubcontract" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>
												<template #cell(diDeliveryDate)="row">
													{{ row.item.diDeliveryDate | moment("DD-MMM-YYYY") }}
												</template>
												<template #cell(diCreateDate)="row">
													{{ row.item.diCreateDate | moment("DD-MMM-YYYY") }}
												</template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                                <b-row>
                                    <b-col>
                                        <b-button variant="success" v-b-toggle.success-content class="m-1">Valid Data ({{ totalSucceedDeliveryInstructionSubcontract.toLocaleString() }})</b-button>
                                        <b-collapse id="success-content">
                                            <div class="table-corner">
                                                <b-table id="success-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="deliveryInstructionSubcontracts" :fields="fieldsDeliveryInstructionSubcontract" :busy="isDataLoading"
                                                         :sort-by.sync="sortByDeliveryInstructionSubcontract" :sort-desc.sync="sortDescDeliveryInstructionSubcontract" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>
												<template #cell(diDeliveryDate)="row">
													{{ row.item.diDeliveryDate | moment("DD-MMM-YYYY") }}
												</template>
												<template #cell(diCreateDate)="row">
													{{ row.item.diCreateDate | moment("DD-MMM-YYYY") }}
												</template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                            </b-tab>                            <b-tab title="Upload Delivery Instruction Subcontract Detail" active>

                                <b-row v-if="hasFailedDataDeliveryInstructionSubcontractDetail">
                                    <b-col>
                                        <b-button variant="danger" v-b-toggle.failed-content class="m-1">Invalid Data ({{ totalFailedDeliveryInstructionSubcontractDetail.toLocaleString() }})</b-button>
                                        <b-collapse visible id="failed-content">
                                            <div class="table-corner">
                                                <b-table id="failed-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="deliveryInstructionSubcontractDetailsFailed" :fields="fieldsDeliveryInstructionSubcontractDetail" :busy="isDataLoading"
                                                         :sort-by.sync="sortByDeliveryInstructionSubcontractDetail" :sort-desc.sync="sortDescDeliveryInstructionSubcontractDetail" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>
												<template #cell(qtyDelivery)="row">
													{{ Number(row.item.qtyDelivery).toLocaleString() }}
												</template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                                <b-row>
                                    <b-col>
                                        <b-button variant="success" v-b-toggle.success-content class="m-1">Valid Data ({{ totalSucceedDeliveryInstructionSubcontractDetail.toLocaleString() }})</b-button>
                                        <b-collapse id="success-content">
                                            <div class="table-corner">
                                                <b-table id="success-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="deliveryInstructionSubcontractDetails" :fields="fieldsDeliveryInstructionSubcontractDetail" :busy="isDataLoading"
                                                         :sort-by.sync="sortByDeliveryInstructionSubcontractDetail" :sort-desc.sync="sortDescDeliveryInstructionSubcontractDetail" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>
												<template #cell(qtyDelivery)="row">
													{{ Number(row.item.qtyDelivery).toLocaleString() }}
												</template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                            </b-tab>

						</b-tabs>
					</b-card>
                </b-col>
            </b-row>
        </b-card>
        <template #modal-footer="{ ok, cancel }">
            <b-button v-if="isUploadSuccess" size="sm" variant="primary" @click="downloadLog()">
                Download Log
            </b-button>
            <b-button size="sm" variant="success" class="float-right" @click="ok()">
                {{ okTitle }}
            </b-button>
            <b-button size="sm" variant="secondary" class="float-right" @click="cancel()">
                Cancel
            </b-button>
        </template>
        <b-overlay :show="isBusy" no-wrap></b-overlay>
    </b-modal>
</template>
<style lang="scss" scoped>
    .card {
        border: 1px solid rgba(0, 0, 0, 0.125) !important;
    }

    ::v-deep.th-message {
        color: red;
    }

    ::v-deep.modal-footer {
        display: block;
    }
</style>
<script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import { saveAs } from 'file-saver';

import DeliveryInstructionSubcontract from '@/models/DeliveryInstructionSubcontract/DeliveryInstructionSubcontract';
import DeliveryInstructionSubcontractList from '@/models/DeliveryInstructionSubcontract/DeliveryInstructionSubcontractList';
import DeliveryInstructionSubcontractFilter from '@/filters/DeliveryInstructionSubcontract/DeliveryInstructionSubcontractFilter';

import AppInputFileupload from '@/components/AppInputFileupload';

export default {
	props: ['model', 'openPopup','uploadButtonMethod', 'parentId'],
	components : {AppInputFileupload,},
	data() {
		return {
			fileupload: null,
			uploadProcessId: null,
			datas: Array(),
			fieldsDeliveryInstructionSubcontract: [
				// {"no" : { "class" : "th-number"}},
				{"class" : "th-id", "label" : "Excel Row", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Id", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Delivery Order", key: 'deliveryOrderDoNumber', sortable: false},
				{"class" : "th-status", "label" : "PO No Customer", key: 'poNoCustomer', sortable: false},
				{"class" : "th-status", "label" : "Delivery Date", key: 'diDeliveryDate', sortable: false},
				{"class" : "th-status", "label" : "Create Date", key: 'diCreateDate', sortable: false},
				{"class" : "th-status", "label" : "Delivery Instruction Status", key: 'diStatusName', sortable: false},
				{"class" : "th-status", "label" : "Customer", key: 'diCustomerCode', sortable: false},
				{"class" : "th-status", "label" : "Part Destination", key: 'partDestinationDestination', sortable: false},
				{"class" : "th-status", "label" : "Destination", key: 'destinationCode', sortable: false},

				{"class" : "th-status", "label" : "Status", key: 'uploadValidationStatus', sortable: false},
				{"class" : "th-message", "label" : "Message", key: 'uploadValidationMessageHtml', sortable: false},
				{"actions": { "class" : "th-actions", "label" : "" }}
			],
			fieldsDeliveryInstructionSubcontractDetail: [
				// {"no" : { "class" : "th-number"}},
				{"class" : "th-id", "label" : "Excel Row", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Id", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Part", key: 'partPartNumber', sortable: false},
				{"class" : "th-status", "label" : "Qty Delivery", key: 'qtyDelivery', sortable: false},
				{"class" : "th-status", "label" : "Delivery Order Detail", key: 'deliveryOrderDetailPoNumber', sortable: false},
				{"class" : "th-status", "label" : "IsNeedRegenerateDc", key: 'isNeedRegenerateDc', sortable: false},
				{"class" : "th-status", "label" : "Qty Actual Supply", key: 'qtyActualSupply', sortable: false},
				{"class" : "th-status", "label" : "Qty Outstanding", key: 'qtyOutstanding', sortable: false},
				{"class" : "th-status", "label" : "Delivery Instruction Status", key: 'deliveryInstructionStatusName', sortable: false},

				{"class" : "th-status", "label" : "Status", key: 'uploadValidationStatus', sortable: false},
				{"class" : "th-message", "label" : "Message", key: 'uploadValidationMessageHtml', sortable: false},
				{"actions": { "class" : "th-actions", "label" : "" }}
			],

			busy:false,
			isDataLoading: false,
			isBusy : false,
			deliveryInstructionSubcontracts : [],
			deliveryInstructionSubcontractsFailed: [],
			deliveryInstructionSubcontractId : '',
			sortByDeliveryInstructionSubcontract: '',
			sortDescDeliveryInstructionSubcontract: '',
			hasFailedDataDeliveryInstructionSubcontract: false,
			totalFailedDeliveryInstructionSubcontract: 0,
			totalSucceedDeliveryInstructionSubcontract: 0,
			deliveryInstructionSubcontractDetails : [],
			deliveryInstructionSubcontractDetailsFailed: [],
			deliveryInstructionSubcontractDetailId : '',
			sortByDeliveryInstructionSubcontractDetail: '',
			sortDescDeliveryInstructionSubcontractDetail: '',
			hasFailedDataDeliveryInstructionSubcontractDetail: false,
			totalFailedDeliveryInstructionSubcontractDetail: 0,
			totalSucceedDeliveryInstructionSubcontractDetail: 0,


			processId: '',
			isUploadSuccess: false,
		}
	},
	methods : {
		resetModal() {
			this.datas = Array();
			this.isUploadSuccess = false;
			this.$emit('resetMethod');
		},
		uploadButtonAction(modalEvent) {
			modalEvent.preventDefault();
			this.isBusy = true;
			if (this.isUploadSuccess) {
				let _this = this;
				this.$http.post('deliveryinstructionsubcontract/confirmUpload/' + _this.uploadProcessId,
					[],
					).then(async function(response){
						if (response != null) {
							if (response.data != null) {
								_this.resetModal();
								_this.datas = Array();
								_this.fileupload = null;
								_this.isUploadSuccess = false;
							}
						}
						_this.isBusy = false;
					})
					.catch(error => {
						_this.$store.dispatch('addErrorMessageGlobal', error);
						_this.isBusy = false;
					});
			} else {
				if (this.fileupload != null) {
					let data = new FormData();
					data.append('file', this.fileupload);
					let _this = this;
					this.$http.post('deliveryinstructionsubcontract/upload',
						data,
						{ headers: { 'Content-Type': 'multipart/form-data' } }
					).then(async function(response){
						_this.uploadProcessId = response.data.id;
						_this.isUploadSuccess = true;
						await _this.getDeliveryInstructionSubcontractForUpload();
					})
					.catch(error => {
						_this.$store.dispatch('addErrorMessageGlobal', error);
						_this.isBusy = false;
					});
				}
			}
		},
		getDeliveryInstructionSubcontractForUpload : async function() {
			let _this = this;
			this.$http.get('deliveryinstructionsubcontract/uploadresult/' + _this.uploadProcessId)
				.then(async function(response) {
					_this.deliveryInstructionSubcontracts = [];
_this.deliveryInstructionSubcontractDetails = [];


					if (response != null) {
						let result = response.data;
						_this.deliveryInstructionSubcontracts = result.filter(o => { return o.uploadValidationStatus == "Success"});
                        _this.totalSucceedDeliveryInstructionSubcontract = _this.deliveryInstructionSubcontracts.length;

						_this.deliveryInstructionSubcontractsFailed = result.filter(o => { return o.uploadValidationStatus != "Success"});
						_this.hasFailedDataDeliveryInstructionSubcontract = true;
						_this.totalFailedDeliveryInstructionSubcontract = 0;
						if(_this.deliveryInstructionSubcontractsFailed == undefined || _this.deliveryInstructionSubcontractsFailed.length === 0) _this.hasFailedDataDeliveryInstructionSubcontract = false;
						if(_this.hasFailedDataDeliveryInstructionSubcontract) _this.totalFailedDeliveryInstructionSubcontract = _this.deliveryInstructionSubcontractsFailed.length;
						_this.deliveryInstructionSubcontractDetails = [];
						_this.deliveryInstructionSubcontractDetailsFailed = [];
						_this.hasFailedDataDeliveryInstructionSubcontractDetail = true;
						_this.totalSucceedDeliveryInstructionSubcontractDetail = 0;
						result.forEach(function(element) {
							_this.deliveryInstructionSubcontractDetails.push(...element.deliveryInstructionSubcontractDetails.filter(o => { return o.uploadValidationStatus == "Success"}));
							_this.totalSucceedDeliveryInstructionSubcontractDetail = _this.deliveryInstructionSubcontractDetails.length;

							_this.deliveryInstructionSubcontractDetailsFailed.push(...element.deliveryInstructionSubcontractDetails.filter(o => { return o.uploadValidationStatus != "Success"}));
							if(_this.deliveryInstructionSubcontractDetailsFailed == undefined || _this.deliveryInstructionSubcontractDetailsFailed.length === 0) _this.hasFailedDataDeliveryInstructionSubcontractDetail = false;
							if(_this.hasFailedDataDeliveryInstructionSubcontractDetail) _this.totalFailedDeliveryInstructionSubcontractDetail = _this.deliveryInstructionSubcontractDetailsFailed.length;
						});
						_this.isBusy = false;
					}
				})
				.catch(error => {
					_this.$store.dispatch('addErrorMessageGlobal', error);
					_this.isBusy = false;
				});
		},
		downloadLog() {
			let _this = this;
			let url = 'deliveryinstructionsubcontract/downloadlog/' + _this.uploadProcessId;
			this.$http.get(url, {responseType: 'blob'}).then(async response => {
				if (response != null) {
					await saveAs(response.data, 'DeliveryInstructionSubcontract.xlsx');
				}
			}).catch(error => {
				this.$store.dispatch('addErrorMessageGlobal', error);
				throw error;
			});
		}
	},
	beforeMount() {
	},
	mounted(){
	},
	watch: {
		fileupload(newValue, oldValue) {
			this.datas = Array();
			this.isUploadSuccess = false;
		}
	},
	computed: {
		okTitle: {
			get: function() {
				if (this.isUploadSuccess) {
					return "Process";
				}
				return "Upload";
				}
		},
		isShowPopup : {
			get: function () {
				if (this.openPopup) {
					this.filterDeliveryInstructionSubcontract = new DeliveryInstructionSubcontractFilter();
					return true;
				}
				else return false;
			},
			set: function (newValue) {}
		},
	}
}
</script>
